<template>
  <div class="card">
    <v-container grid-list-md>
      <v-layout
        row
        wrap
      >
        <v-flex
          v-for="person in items.people"
          :key="person.id"
          class="card__flex"
          xs6
          sm4
          md4
          lg3
        >
          <v-card
            flat
            class="card__item elevation-7"
            :class="margin"
            color="white"
          >
            <v-card-actions
              v-if="checklogin"
              class="pa-0"
            >
              <v-spacer />

              <v-btn
                v-if="!isBookmark && !isFavor(person.id)"
                slot="activator"
                flat
                icon
                color="blue-grey lighten-1"
                @click="addToFavor(person)"
              >
                <v-icon>bookmark</v-icon>
              </v-btn>

              <v-btn
                v-else-if="!isBookmark && isFavor(person.id)"
                slot="activator"
                flat
                icon
                color="blue-grey lighten-1"
                @click="deleteFromFavor(getIndex(person.id), person.name, $event)"
              >
                <v-icon color="amber accent-4">
                  bookmark
                </v-icon>
              </v-btn>

              <v-btn
                v-else-if="isBookmark"
                slot="activator"
                flat
                icon
                color="blue-grey lighten-1"
                @click="deleteFromFavor(person.fbId, person.name, $event)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-actions>
            <router-link
              class="card__link"
              :to="'/person/' + person.id"
            >
              <div class="card__picture">
                <v-lazy-image
                  class="card__img"
                  :src="person.profile_path ? `${profilePrefix}${person.profile_path}` : noPosterSrc"
                  :src-placeholder="person.profile_path ? `${placeholder}${person.profile_path}` : noPoster"
                />
              </div>
              <div class="card__content text-no-wrap text-truncate">
                <h2 class="name body-2 ma-0">
                  {{ person.name }}
                </h2>
                <span class="caption">({{ getKnownForTitle(person.known_for) }})</span>
              </div>
            </router-link>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-unresolved
import { base } from '@/config/config';

const noPosterSrc = require('../assets/noposter.jpg');

export default {
  props: {
    items: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      profilePrefix: base.imgPrefix,
      placeholder: base.profilePlaceholder,
      noPosterSrc,
      noPoster:
        'data:image/jpeg;base64,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',
    };
  },
  computed: {
    ...mapState({
      getFavList(state) {
        return state.favors.favors.people;
      },
    }),
    checklogin() {
      return this.$store.getters.login;
    },
    isBookmark() {
      return this.$route.name === 'bookmarks';
    },

    margin() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'mx-0 mb-3';
        case 'sm':
          return 'mx-1 mb-3';
        case 'md':
          return 'mx-2 mb-3';
        case 'lg':
          return 'mx-3 mb-4';
        case 'xl':
          return 'mx-3 mb-4';
        default:
          return 'mx-3 mb-4';
      }
    },
  },
  methods: {
    addToFavor(person) {
      // eslint-disable-next-line no-param-reassign
      person.type = 'person';
      this.$store.dispatch('addToFavorList', person);
    },
    deleteFromFavor(id, title, event) {
      const card = event.target.closest('.card__item');

      if (this.$route.name !== 'bookmarks') {
        const index = this.getFavList[id].fbId;
        this.$store.dispatch('deleteFromFavorList', { index, title });
      } else {
        const getAction = () => {
          card.parentElement.remove();
          this.$store.dispatch('deleteFromFavorList', { id, title });
        };

        card.style.transform = 'scale(0)';
        card.style.opacity = '0';
        setTimeout(() => {
          getAction();
        }, 400);
      }
    },
    isFavor(id) {
      return this.getFavList.findIndex(el => el.id === id) !== -1;
    },
    getIndex(id) {
      return this.getFavList.findIndex(el => el.id === id);
    },
    getKnownForTitle(knownFor) {
      let kfTitle = '';
      if (knownFor) {
        if (knownFor.length > 0) {
          if (knownFor[0].title) {
            kfTitle = knownFor[0].title;
          } else if (knownFor[0].name) {
            kfTitle = knownFor[0].name;
          }
        }
      }
      return kfTitle;
    },
  },

};
</script>

<style lang="scss" scoped>
.v-lazy-image {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  filter: blur(10px);
  transition: filter 0.7s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}

.card {
  &__flex {
    position: relative;
    transition: transform 0.25s ease-in-out;

    &:hover {
      @media (min-width: 959px) {
        transform: translateY(-10px);
        // transform: scale(1.02);
      }
    }
  }

  &__item {
    transition: all 0.4s ease-in-out;
  }

  &__link {
    text-decoration: none;
  }

  &__content {
    // position: absolute;
    // bottom: 0;
    // background: rgba(0, 0, 0, 0.5);
    // width: 100%;
    color: white;
    color: #303030;
    padding: 10px;
    text-align: center;

    .name {
      font-size: 16px !important;
    }
  }

  &__details {
    text-align: center;
  }

  &__picture {
    position: relative;
    padding-bottom: 145%;
    overflow: hidden;
  }

  &__progress {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }
}
</style>
